import './Stylesheets/App.css';
import { lazy, Suspense, useEffect } from 'react';
import { initScrollReveal } from './Utils/scrollReveal';
import Navbar from './Navbar';
import Landing from './Landing';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// Below-fold main page sections — lazy loaded
const Schedule     = lazy(() => import('./Schedule'));
const Coaches      = lazy(() => import('./Coaches'));
const Testimonials = lazy(() => import('./Components/Testimonials'));
const Pricing      = lazy(() => import('./Pricing'));
const FAQ          = lazy(() => import('./FAQ'));
const Contact      = lazy(() => import('./Contact'));
const Footer       = lazy(() => import('./Footer'));

const StatsBar = lazy(() => import('./Components/StatsBar'));

// Separate routes — lazy loaded
const Blog        = lazy(() => import('./Blog'));
const FullPost    = lazy(() => import('./Components/FullPost'));
const SuccessPage = lazy(() => import('./Components/SuccessPage'));
const CancelPage  = lazy(() => import('./Components/CancelPage'));

function App() {
  useEffect(() => initScrollReveal(), []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <div>
            <Suspense fallback={null}>
              <Routes>
                <Route path="/success" element={<SuccessPage />} />
                <Route path="/cancel" element={<CancelPage />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<FullPost />} />
                <Route
                  path="/*"
                  element={
                    <>
                      <Navbar />
                      <Landing />
                      <Coaches />
                      <StatsBar />
                      <Testimonials />
                      <Schedule />
                      <div className="slant slant--major slant--rtl" style={{ background: '#080808' }} aria-hidden="true" />
                      <Pricing />
                      <FAQ />
                      <Contact />
                      <Footer />
                    </>
                  }
                />
              </Routes>
            </Suspense>
          </div>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
